import { stateTypes, getterTypes } from './unit.moduletypes';

import {} from '../models/unit.models';

import actions from './unit.moduleactions';
import mutations from './unit.modulemutations';

import UnitApi from '../services/unit.api';

export default {
  // see https://vuex.vuejs.org/guide/modules.html#namespacing
  namespaced: true,

  state: {
    [stateTypes.units]: [],
    [stateTypes.currentUnit]: {
      groups: []
    },
    [stateTypes.currentMachine]: {
      name: '',
      machineOem: '',
      machineWires: []
    },
    [stateTypes.currentWires]: {},
    [stateTypes.wiresOptionForPosition]: [],
    [stateTypes.machinesConfigurations]: null,
    [stateTypes.copyConfiguration]: [],
    [stateTypes.easySetup]: []
  },
  getters: {
    /**
     * here we setup UnitApi _once_, it's cached through dependency chain
     * and available through getters.UnitApi for actions
     */
    [getterTypes.UnitApi]: (state, getters, rootState) => {
      // let settings = rootState.applicationState
      //   ? rootState.applicationState.initialSettings
      //   : window.infos.initialSettings;
      return new UnitApi();
    },
    [getterTypes.getAllUnits]: state => {
      return state[stateTypes.units];
    },
    [getterTypes.getCurrentUnit]: state => {
      return state[stateTypes.currentUnit];
    },
    [getterTypes.getCurrentMachine]: state => {
      return state[stateTypes.currentMachine];
    },
    [getterTypes.getCurrentWires]: state => {
      return state[stateTypes.currentWires];
    },
    [getterTypes.getWiresOptionForPosition]: state => {
      return state[stateTypes.wiresOptionForPosition];
    },
    [getterTypes.getMachinesConfigurations]: state => {
      return state[stateTypes.machinesConfigurations];
    },
    [getterTypes.getMatchingMachinesConfigurations]: state => {
      return state[stateTypes.machinesConfigurations];
    },
    [getterTypes.getCopyConfiguration]: state => {
      return state[stateTypes.copyConfiguration];
    },
    [getterTypes.getEasySetupData]: state => {
      return state[stateTypes.easySetup];
    }
  },

  mutations: mutations,

  actions: actions
};
